// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const smeargle: PokeData = {
  "id": 235,
  "name": "smeargle",
  "height": 12,
  "weight": 580,
  "base_experience": 88,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "sketch"
  ],
  "moves": [
    "scary-face",
    "splash",
    "tri-attack",
    "scratch",
    "purification",
    "leer",
    "quick-attack",
    "supersonic",
    "refresh",
    "protect",
    "body-slam",
    "headbutt",
    "growl"
  ],
  "evolution_chain": {
    "id": 121,
    "item": null,
    "species": [
      {
        "name": "smeargle",
        "order": 266,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 95,
    "speed": 150,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
